import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import { setLang } from '@modules/ui';

const loadLocaleData = async (lng) => {
  try {
    const response = await fetch(`https://lgpk.coursemos.io/studio/${lng}`);
    if (!response.ok) {
      console.error(`Error: ${response.status} - ${response.statusText}`);
      throw new Error(`Failed to load ${lng} locale data`);
    }
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    return {}; // 오류 시 빈 객체 반환
  }
};

// i18n 초기화 함수: 반드시 lang(문자열)과 dispatch를 파라미터로 받음
//const initializeI18n = async (lang, dispatch) => {
const initializeI18n = async (lang) => {
  const defaultResources = await loadLocaleData(lang.locale);
  const resources = {
    [lang.locale]: {
      translation: defaultResources
    }
  };

  i18n
    .use(initReactI18next)
    .init({
      resources: resources,
      lng: lang.locale,
      fallbackLng: 'ko-KR',  // 지원하지 않는 언어인 경우 한국어로 폴백
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: false,
        bindI18n: 'languageChanged loaded',
      },
      debug: true
    });

  i18n.on('languageChanged', async (lng) => {
    console.log(`언어 변경됨: ${lng}`);
    if (!i18n.hasResourceBundle(lng, 'translation')) {
      const newResources = await loadLocaleData(lng);
      i18n.addResourceBundle(lng, 'translation', newResources, true, true);
    }
  });
};

const changeLanguage = async (lang) => {
  if (i18n.language !== lang.locale) {
    try {
      // 언어 데이터 먼저 로드
      if (!i18n.hasResourceBundle(lang.locale, 'translation')) {
        const newResources = await loadLocaleData(lang.locale);
        i18n.addResourceBundle(lang.locale, 'translation', newResources, true, true);
      }
      // 언어 변경
      await i18n.changeLanguage(lang.locale);
      document.documentElement.lang = lang.locale;
      console.log(`언어 적용됨: ${lang.locale}`);
      // 강제 이벤트 발생 (추가 안전장치)
      i18n.emit('languageChanged', lang.locale);
    } catch (error) {
      console.error("언어 변경 중 오류 발생:", error);
    }
  }
};

export default i18n;
export { loadLocaleData, initializeI18n, changeLanguage };